@if (meta) {
<small-screen-modal
  class="-overlay-container"
  [ngClass]="{ '-overlay-slide-in': sidebarShow }"
  (click)="sidebarEventHandler()"></small-screen-modal>
<span
  class="sidebar-slider"
  [class.sidebar-slide-in]="sidebarShow"
  [ngClass]="
    meta.template === globals.TEMPLATE_TYPES.API_OVERVIEW
      ? '-no-sec-nav-offset'
      : isSecNav
      ? meta['subscription-group']
        ? '-sec-nav-with-release-notes-offset'
        : '-sec-nav-offset'
      : '-no-sec-nav-offset'
  ">
  <!-- TODO: Remove the below two lines when new sidebar is implemented on all pages -->
  @if (!isSidebarPresent) {
  <nav-vertical-updated
    [ngClass]="{
      '-doc-page-nav':
        (meta.template === 'doc-page' || meta.template === 'product-landing' || meta.template === 'prod-doc-page') &&
        (meta['sec-nav'] || meta['secondary-nav']),
      '-hide-sec-nav': !isSecNav
    }"
    slideNav="slideNav"></nav-vertical-updated>
  } @if (!isSidebarPresent) {
  <div class="sidebar-opener" (click)="sidebarEventHandler()"></div>
  } @if (isSidebarPresent) {
  <app-sidebar
    [menu]="meta"
    [ngClass]="{
      '-doc-page-nav':
        (meta.template === 'doc-page' || meta.template === 'product-landing' || meta.template === 'prod-doc-page') &&
        (meta['sec-nav'] || meta['secondary-nav']),
      '-hide-sec-nav': !isSecNav
    }"
    slideNav="slideNav"></app-sidebar>
  }
</span>
} @if (!meta) {
<small-screen-modal
  class="-overlay-container"
  [ngClass]="{ '-overlay-slide-in': sidebarShow }"
  (click)="sidebarEventHandler()"></small-screen-modal>
<span class="sidebar-slider -no-sec-nav-offset" [class.sidebar-slide-in]="sidebarShow">
  @if (!isSidebarPresent) {
  <nav-vertical-updated
    [allowLoaderControl]="false"
    slideNav="slideNav"
    [ngClass]="{ '-account': !meta }"></nav-vertical-updated>
  } @if (!isSidebarPresent) {
  <div class="sidebar-opener" (click)="sidebarEventHandler()"></div>
  } @if (isSidebarPresent) {
  <app-sidebar [allowLoaderControl]="false" slideNav="slideNav" [ngClass]="{ '-account': !meta }"></app-sidebar>
  }
</span>
}
